// src/constants/colors.js
export const COLORS = {
  primary: "#0284C7",        // sky-600
  primaryLight: "#E0F2FE",   // sky-100
  primaryDark: "#0369A1",    // sky-700
  secondary: "#FACC15",      // yellow-400
  background: "#FFFFFF",
  textPrimary: "#1E293B",
  textSecondary: "#475569",
  white: "#FFFFFF",
  dark: "#0F172A",
  light: "#F8FAFC",
  medium: "#E2E8F0",
  gradientHero: "linear-gradient(to bottom right, #E0F2FE, #FFFFFF)",
};
